export const AUTO_DATE_INTERVAL_MS = 1000;
export const DEFAULT_POLL_INTERVAL_MS = 3000;
export const INPUT_DEBOUNCE_MS = 300;
export const RESIZE_THROTTLE_MS = 500;
export const STATUS_MESSAGE_AUTO_DISMISS_MS = 6000;
export const SORT_TIMEOUT_MS = 250;
export const ONE_MINUTE_IN_MILLISECONDS = 60000;
